import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Send } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-128">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[#0a0a0a] z-0" data-id="element-129">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#c9a96e]/10 rounded-full blur-[120px]" data-id="element-130" />
        <div className="absolute bottom-0 right-1/4 w-[600px] h-[600px] bg-[#c9a96e]/5 rounded-full blur-[100px]" data-id="element-131" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20" data-id="element-132" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full flex flex-col items-center text-center" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-134">
          <span className="inline-block py-1 px-3 rounded-full border border-[#c9a96e]/30 bg-[#c9a96e]/10 text-[#c9a96e] text-xs uppercase tracking-[0.2em] mb-6" data-id="element-135">
            Premium Escort Directory
          </span>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif font-bold text-white mb-4 leading-tight" data-id="element-136">
            <span className="text-[#c9a96e]" data-id="element-137">SGHarem.site</span> 新加坡后宫网
          </h1>
          <p className="text-xl md:text-2xl text-neutral-400 font-light tracking-wide mb-12 max-w-2xl mx-auto" data-id="element-138">
            新加坡后宫网是高端伴游陪游按摩援交一站式平台，为新加坡绅士提供优质伴游、按摩娱乐体验，覆盖全新加坡。
            <span className="block text-sm md:text-base mt-3 text-[#c9a96e]/80 leading-relaxed" data-id="element-139">
              SGHarem, Singapore's high-class escort directory connecting you
              with premium companions, massage services, and escorts across
              Singapore.
            </span>
          </p>
        </motion.div>

        {/* Entry Buttons */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="w-full max-w-3xl flex flex-col sm:flex-row gap-4" data-id="element-140">
          <a href="https://geylang777-6.site/" target="_blank" rel="noopener noreferrer" className="flex-1 h-14 bg-[#c9a96e] hover:bg-[#d4af37] text-black font-semibold rounded-lg transition-all duration-300 flex items-center justify-center gap-3 shadow-[0_0_20px_rgba(201,169,110,0.3)] hover:shadow-[0_0_30px_rgba(201,169,110,0.5)]" data-id="element-141">
            <Globe size={22} data-id="element-142" />
            <span data-id="element-143">官方网站入口</span>
          </a>
          <a href="https://www.cfge.me" target="_blank" rel="noopener noreferrer" className="flex-1 h-14 bg-[#c9a96e] hover:bg-[#d4af37] text-black font-semibold rounded-lg transition-all duration-300 flex items-center justify-center gap-3 shadow-[0_0_20px_rgba(201,169,110,0.3)] hover:shadow-[0_0_30px_rgba(201,169,110,0.5)]" data-id="element-144">
            <Globe size={22} data-id="element-145" />
            <span data-id="element-146">新加坡春风阁</span>
          </a>
          <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="flex-1 h-14 bg-[#111111]/80 backdrop-blur-lg border border-[#c9a96e]/40 text-[#c9a96e] font-semibold rounded-lg transition-all duration-300 flex items-center justify-center gap-3 hover:border-[#c9a96e] hover:shadow-[0_0_20px_rgba(201,169,110,0.15)]" data-id="element-147">
            <Send size={20} data-id="element-148" />
            <span data-id="element-149">Telegram 频道</span>
          </a>
        </motion.div>

        {/* Stats */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.5
      }} className="mt-16 flex flex-wrap justify-center gap-8 md:gap-16 text-center" data-id="element-150">
          {[{
          label: 'Active Companions',
          value: '150+'
        }, {
          label: 'Verified Profiles',
          value: '100%'
        }, {
          label: 'Satisfaction',
          value: '4.9/5'
        }].map((stat, index) => <div key={index} className="flex flex-col items-center" data-id="element-151">
              <span className="text-3xl font-serif font-bold text-[#c9a96e]" data-id="element-152">
                {stat.value}
              </span>
              <span className="text-sm text-neutral-500 uppercase tracking-wider mt-1" data-id="element-153">
                {stat.label}
              </span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}